<template>
  <div class="pushStatusBox">
    <button v-show="hasPushError" class="warningBtn">{{$t('lang.outputAlert')}}</button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {

  },
  data () {
    return {
      hasPushError: false,
      getSharingSocialTimer: null
    }
  },
  created () {
  },
  computed: {
    sharingErrorInfo () {
      return this.$store.state.mediaInitParams.sharingErrorInfo
    }
  },
  watch: {
    sharingErrorInfo (newVal) {
      this.hasPushError = newVal && newVal.errorCount > 0
    }
  }

}
</script>

<style lang="less" scoped>
.warningBtn {
  -webkit-animation-name: greenPulse;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  width: 144px;
  height: 32px;
  background: #E56464;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.2) 0px -2px 0px 0px;
  color: rgb(255, 255, 255);
  border-radius: 4px;
  outline-color: rgb(255, 255, 255);
  font-weight: 700;
}
@-webkit-keyframes greenPulse {
  from { background-color: #E56464; -webkit-box-shadow: 0 0 9px #333; }
  50% { background-color: #B54444; -webkit-box-shadow: 0 0 18px #bb4578; }
  to { background-color: #E56464; -webkit-box-shadow: 0 0 9px #333; }
}
</style>
